import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import HttpSrcDirectiveController from "./HttpSrcDirectiveController";

export default class HttpSrcDirective implements IDirective {
    public bindToController = {
        irHttpSrc: "<",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = HttpSrcDirectiveController;
    }
}

module("mmGui").directive("irHttpSrc", () => new HttpSrcDirective());
